export enum EBackendTag {
  APARTMENTS = 'Apartments',
  APARTMENTS_FIT = 'ApartmentsFit',
  AREAS = 'Areas',
  BUILDINGS = 'Buildings',
  BUILDINGS_USAGE = 'BuildingsUsage',
  BUILDING_APARTMENTS = 'BuildingApartments',
  BUILDING_DEFAULTS = 'BuildingDefaults',
  COSTS = 'Costs',
  CREDITS = 'Credits',
  DATA_OVERVIEW = 'DataOverview',
  DAYLIGHT = 'Daylight',
  DIMENSION_IMAGES = 'DimensionImages',
  ENERGY = 'Energy',
  ENERGY_DEMAND = 'EnergyDemand',
  FAHRLANDER_BUILDING_SETTINGS = 'FahrlanderBuildingSettings',
  FAHRLANDER_FUNCTIONS = 'FahrlanderFunctions',
  FAHRLANDER_PLOT_ACCESS = 'FahrlanderPlotAccess',
  FAHRLANDER_PROJECT_ACCESS = 'FahrlanderProjectAccess',
  FAHRLANDER_SUBSCRIPTION_ACCESS = 'FahrlanderSubscriptionAccess',
  IMAGES = 'Images',
  INCOMES = 'Incomes',
  INVALID_AFTER_SAVE = 'InvalidAfterSave',
  IRRADIATION = 'SolarIrradiation',
  KEE_VALUE_SUBSCRIPTION_ACCESS = 'KeeValueSubscriptionAccess',
  PARKING_LOTS = 'ParkingLots',
  PARKING_LOTS_RESULTS = 'ParkingLotsResults',
  PARKING_LOT_FINANCE = 'ParkingLotFinance',
  PROJECT = 'Project',
  PROJECTS = 'Projects',
  PROJECT_AREAS = 'ProjectAreas',
  PROJECT_COLLABORATORS = 'ProjectCollaborators',
  PROJECT_ERRORS = 'ProjectErrors',
  PROJECT_EXISTING_BUILDINGS = 'ProjectExistingBuildings',
  PROJECT_FINANCE = 'ProjectFinance',
  PROJECT_LANDSCAPE = 'ProjectLandscape',
  PROJECT_MAP_FEATURES = 'ProjectMapFeatures',
  PROJECT_MODIFIED_TERRAIN = 'ProjectModifiedTerrain',
  PROJECT_NOTES = 'ProjectNotes',
  PROJECT_RULES_CHECK = 'ProjectRulesCheck',
  PROJECT_VOLUMES = 'ProjectVolumes',
  PURCHASE_INFO = 'PurchaseInfo',
  USER = 'User',
  USER_PROJECT_RULES = 'UserProjectRules',
  UTILITIES = 'Utilities',
  UTILIZATION = 'Utilization',
  VISUALIZATION = 'Visualization',
  WINDOWS_SOLAR_HEAT_GAIN = 'WindowsSolarHeatGain',
  WITH_LANGUAGE = 'WithLanguage',
}

export enum EBackendMutationCacheKey {
  ADD_BUILDING = 'addBuilding',
  ADD_PARKING_LOT = 'addParkingLot',
  EDIT_BUILDING_CIRCULATION = 'editBuildingCirculation',
  UPDATE_BUILDINGS = 'updateBuildings',
  UPDATE_FACADES = 'updateFacades',
  UPDATE_PARKING_LOTS = 'updateParkingLots',
  UPDATE_PHOTOVOLTAICS = 'updatePhotovoltaics',
  UPDATE_USER_PROJECT_RULES = 'updateUserProjectRules',
  UPDATE_VEGETATION = 'updateVegetation',
  UPDATE_BUILDINGS_USAGE = 'updateBuildingsUsage',
  UPDATE_MODIFIED_TERRAIN = 'updateModifiedTerrain',
  UPDATE_ENERGY_DEMAND = 'updateEnergyDemand',
  CREATE_CONSTRUCTION_WINDOW_FEATURE = 'createConstructionWindowFeature',

  // Costs
  EDIT_COST_DATA_SOURCE = 'editCostDataSource',
  EDIT_BKP_COSTS_LIBRARY = 'editBkpCostsLibrary',
  EDIT_COST_TYPE = 'editCostType',
  SET_GENERAL_COST_SETTING_VALUE = 'setGeneralCostSettingValue',
  SET_FINANCING_COST_SETTING_VALUE = 'setFinancingCostSettingValue',
  SET_RETURN_FINANCE_SETTING_VALUE = 'setReturnFinanceSettingValue',
  SET_FORWARD_DEAL_FINANCE_SETTING_VALUE = 'setForwardDealFinanceSettingValue',

  // Income
  EDIT_INCOME_DATA_SOURCE = 'editIncomeDataSource',
  EDIT_INCOME_TYPE = 'editIncomeType',
  EDIT_PROJECT_RENT_INCOME_LIBRARY = 'editProjectRentIncomeLibrary',
  EDIT_PROJECT_SALE_INCOME_LIBRARY = 'editProjectSaleIncomeLibrary',
  IMPORT_FAHRLANDER_RENT_INCOMES = 'importFahrlanderRentIncome',
  IMPORT_FAHRLANDER_SALE_INCOMES = 'importFahrlanderSaleIncomes',
}
